import * as React from 'react';
import { observer } from 'mobx-react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';

const styles = require('./GroupView.scss');

export interface GroupViewProps {
    itemIndex: number;
    isSelected: boolean;
    groupSmtpEmailAddress: string;
    primaryText: string;
    ariaLabel: string;
    secondaryText?: string;
    className?: string;
    onSelectedClassName?: string;
}

@observer
export default class GroupView extends React.Component<GroupViewProps, {}> {
    private groupContainer: HTMLDivElement;

    render() {
        return (
            <div
                className={styles.groupContainer}
                ref={ref => (this.groupContainer = ref)}
                onMouseDown={this.focusOnGroupViewOnMouseDown}
                aria-label={this.props.ariaLabel}
                data-is-focusable={true}
                tabIndex={-1}
                data-selection-invoke={true}
                data-selection-index={this.props.itemIndex}
                title={this.props.primaryText}>
                <div className={styles.iconContainer}>
                    <PersonaControl
                        emailAddress={this.props.groupSmtpEmailAddress}
                        name={this.props.primaryText}
                        size={PersonaSize.size48}
                        showPersonaDetails={false}
                    />
                </div>
                <div className={styles.infoContainer}>
                    <div className={styles.width100percentForEllipsis}>
                        <div className={styles.primaryText}>{this.props.primaryText}</div>
                        <div className={styles.secondaryText}>{this.props.secondaryText}</div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.itemIndex === 0) {
            this.focus();
        }
    }

    focus() {
        this.groupContainer.focus();
    }

    private focusOnGroupViewOnMouseDown = (evt: React.MouseEvent<EventTarget>) => {
        // If a click happens on the child container then we need to change the focus
        // back to the parent container of the group view.
        evt.stopPropagation();
        evt.preventDefault();
        this.focus();
    };
}
